import { render, staticRenderFns } from "./ReferralSummary.vue?vue&type=template&id=2403dc88&scoped=true&"
import script from "./ReferralSummary.vue?vue&type=script&lang=js&"
export * from "./ReferralSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2403dc88",
  null
  
)

export default component.exports